import { useEffect, useState } from 'react';
import { getApiCarriers } from '@/services/submission.service.js';

// Which carriers can actually be quoted through an API right now, and for
// which one the door is real.
//
// Measured against PRODUCTION on 2026-08-05:
//   IAT    → environment 'prod',  https://iatflightapi.com,  credentials set
//   Global → environment 'test',  https://uatexternalservices.global-aero.com,
//            and a `dev-` Auth0 tenant
//
// So "Quote with Global" has been a live-looking control pointed at Global's
// UAT from production. A control that silently does nothing is worse than no
// control, so it is hidden until GLOBAL_ENVIRONMENT=prod (plus the PROD_*
// credentials) is set on Render. Nothing here hard-codes that verdict — each
// integration reports its own environment, so configuring production makes the
// button appear with no code change and no second copy of the fact.

export const API_CARRIER_SLUGS = ['iat', 'global_aerospace'];

const LABEL = { iat: 'IAT', global_aerospace: 'Global' };

export function apiCarrierLabel(slug) {
  return LABEL[slug] || slug;
}

/**
 * { ready: { iat: bool, global_aerospace: bool }, loaded: bool }
 * Failure to answer is NOT readiness: a status call that throws leaves the
 * carrier false, so a down probe hides the button rather than offering a fire
 * that cannot work.
 */
export function useApiCarrierReadiness() {
  const [ready, setReady] = useState({ iat: false, global_aerospace: false });
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let dead = false;
    getApiCarriers()
      .then((d) => {
        if (dead) return;
        const c = d?.carriers || {};
        setReady({
          iat: c.iat?.ready === true,
          global_aerospace: c.global_aerospace?.ready === true,
        });
        setLoaded(true);
      })
      .catch(() => { if (!dead) setLoaded(true); });
    return () => { dead = true; };
  }, []);

  return { ready, loaded };
}
